/**
 * NetworkLedgerHero — the `/network/ledger` design.
 *
 * Verbatim render of `network-ledger.html` (modules in
 * ./landing/network-ledger/). Real app routes are wired through
 * `wireLinks={true}`; external links (https://) are left alone.
 */
import { STYLES } from "./landing/network-ledger/styles";
import { MARKUP } from "./landing/network-ledger/markup";
import { SCRIPT } from "./landing/network-ledger/script";
import { PageHost } from "./landing/PageHost";

export function NetworkLedgerHero() {
  return (
    <PageHost
      styles={STYLES}
      markup={MARKUP}
      script={SCRIPT}
      hostClass="trex-ledger-host"
      wireLinks={true}
      data-testid="network-ledger-hero"
    />
  );
}
